import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";

// Optimize store creation
const store = configureStore({ 
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// Use React.memo for better performance
const RootComponent = React.memo(() => (
  <Provider store={store}>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <App />
    </BrowserRouter>
  </Provider>
));

root.render(<RootComponent />);

// Report web vitals only in development
if (process.env.NODE_ENV === 'development') {
  reportWebVitals(console.log);
} 